/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import App from "./helpers/app";
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import Cookies from 'js-cookie';
import {decode_yii_cookie, is_breakpoint_up} from "./helpers/functions";
import Alpine from 'alpinejs';
import Swiper from './libs/swiper';

Alpine.start();

const axios = require("axios").default;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

require("bootstrap");
require("fslightbox");
require("sticky-kit/dist/sticky-kit.min");
require("hammerjs");

require("./helpers/jquery");
require("./helpers/functions");

require("./libs/jquery.browser");
require("./libs/jquery.address");

require("./base");

require("./sections/how-work");
require("./sections/newsletter");

require("./partials/bar");
require("./partials/filters");
require("./partials/offers-config");

require("./widgets/cookies-info");
require("./widgets/lead-aside");
require("./widgets/icons-menu");

// require("./pages/lead");
require("./pages/new-lead");
require("./pages/home");
require("./pages/offer-detail");
require("./pages/offer-detail-used");
require("./pages/offers-list");
require("./pages/blog-article");
require("./pages/blog-shortcodes");
require("./pages/about");
require("./pages/contact");
require("./pages/calculation");
require("./pages/advanced-search");

$(function() {
  App.bootstrap();
});

require("./../../vendor/yiisoft/yii2/assets/yii");
require("./../../vendor/yiisoft/yii2/assets/yii.activeForm");
require("./../../vendor/yiisoft/yii2/assets/yii.validation");

require('select2');
require('select2/src/js/select2/i18n/pl');
$.fn.select2.defaults.set('theme', 'bootstrap4');
$.fn.select2.defaults.set('language', 'pl');
$.fn.select2.defaults.set('width', 'style');

let helpers = {
  decode_yii_cookie: decode_yii_cookie
}

global.helpers = helpers;
global.is_breakpoint_up = is_breakpoint_up;
global.jQuery = global.$ = require("jquery");
global.Cookies = Cookies;
global.app = App;
global.axios = axios;
global.Alpine = Alpine
global.Swiper = Swiper
